<template>
  <footer
    v-if="visitLabel || address"
    class="review-card-footer d-flex text-body-2 text-secondary--text"
    :class="isMobile
      ? 'flex-wrap ga-2'
      : 'review-card-footer--desktop align-start'"
  >
    <div
      v-if="visitLabel"
      class="review-card-footer__visit d-flex align-center flex-shrink-0"
    >
      <span class="ui-icon-calendar-none ui-icon-fz-medium mr-2" />
      <span>
        {{ tStatic('Приём был в') }}
        {{ visitLabel }}
      </span>
    </div>
    <div
      v-if="address"
      class="review-card-footer__address"
    >
      {{ address }}
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/index/types'
import useContextStore from 'src/store/useContextStore'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import { formatVisitMonth } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/formatReviewDates'

const props = defineProps<{
  rate: Rate
}>()

const isMobile = useIsMobile()
const { context }: ContextStore = useContextStore()
const visitLabel = computed(() => formatVisitMonth(
  props.rate.dt_visit,
  Boolean(context.request.country.is_russia),
  context.current_language.iso,
))
const address = computed(() => (
  props.rate.get_lpu_address
  || (props.rate.lpuaddr
    ? `${tDynamic(props.rate.lpuaddr.lpu, 'name')} - ${props.rate.lpuaddr.address || ''}`
    : props.rate.lpuaddr_text)
  || ''
))
</script>

<style scoped lang="scss">
.review-card-footer {
  &__address {
    flex: 1 1 100%;
    min-width: 0;
  }

  &--desktop {
    max-width: 554px;
  }

  &--desktop &__visit {
    padding-right: 24px;
  }

  &--desktop &__address {
    flex: 1 1 0;
    min-width: 0;
    text-align: right;
  }
}
</style>
